import { render } from "./StatusMessage.vue?vue&type=template&id=61993867"
import script from "./StatusMessage.vue?vue&type=script&lang=js"
export * from "./StatusMessage.vue?vue&type=script&lang=js"

import "./StatusMessage.vue?vue&type=style&index=0&id=61993867&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__